import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService, UserRole } from 'src/app/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FormGroup, FormBuilder } from '@angular/forms';

import { map } from 'rxjs/operators';

import { ChatService } from 'src/app/chat/common/services/chat.service';
import { AccountService } from 'src/app/account/common/services/account.service';

declare var $: any;

@Component({
	selector: 'app-admin-sidebar',
	templateUrl: './AdminSidebar.component.html',
	styleUrls: ['./AdminSidebar.component.scss'],
})
export class AdminSidebarComponent implements OnInit {

	get isUserLogged(): boolean {
		return this.authService.isAuthenticated;
	}

	get profileAvatar(): SafeResourceUrl {
		return this.authService.getProfileAvatar;
	}

	get profileName(): string {
		return this.authService.getProfileName;
	}

	get userCounty(): string {
		return this.authService.userCountyFromStorage;
	}

	get availability(): boolean {
		return this.availForm.controls.availability.value;
	}

	// sidebarIn : boolean = false;
	constructor(
		private authService: AuthService,
		private chatService: ChatService,
		private fb: FormBuilder,
		private accountService: AccountService
	) { }
	availForm: FormGroup;

	isUserAvailable = false;

	sidebarItems = [
		{
			name: 'Moja galeria',
			link: '/gallery',
			image: './assets/images/private-page/gallery.svg',
		},
		{
			name: 'Moje artykuły',
			link: '/articles/manage/list',
			image: './assets/images/private-page/articles.svg',
		},
		{
			name: 'Moje wpisy',
			link: '/blog/manage/list',
			image: './assets/images/private-page/blog.svg',
		},
		{
			name: 'Moje przejazdy',
			link: '/trip-planner/manage/list',
			image: './assets/images/private-page/trip.svg',
		},
		{
			name: 'Zakupy z Trekmondo',
			link: '/account/voucher',
			href: 'https://trekmondo.pl/',
			image: './assets/images/private-page/store.svg',
		},
		{
			name: 'Subskrypcje',
			link: '/account/my-subscriptions',
			image: './assets/images/private-page/subscription.svg',
		},
		{
			name: 'Edytuj profil',
			link: '/account/profile',
			image: './assets/images/private-page/profile.svg',
		},
		{
			name: 'Zmień hasło',
			link: '/account/change-password',
			image: './assets/images/private-page/password.svg',
		},
	];

	editorSidebarItems = [
		{
			name: 'Moja galeria',
			link: '/gallery',
			image: './assets/images/private-page/gallery.svg',
		},
		{
			name: 'Artykuły',
			link: '/articles/manage/list',
			image: './assets/images/private-page/articles.svg',
		},
		{
			name: 'Wpisy',
			link: '/blog/manage/list',
			image: './assets/images/private-page/blog.svg',
		},
		{
			name: 'Komentarze',
			link: '/comments/manage/list',
			image: './assets/images/private-page/trip.svg',
		},
		{
			name: 'Przejazdy',
			link: '/trip-planner/manage/list',
			image: './assets/images/private-page/trip.svg',
		},
		{
			name: 'Zakupy z Trekmondo',
			link: '/account/voucher',
			image: './assets/images/private-page/store.svg',
		},
		{
			name: 'Subskrypcje',
			link: '/account/my-subscriptions',
			image: './assets/images/private-page/subscription.svg',
		},
		{
			name: 'Edytuj profil',
			link: '/account/profile',
			image: './assets/images/private-page/profile.svg',
		},
		{
			name: 'Zmień hasło',
			link: '/account/change-password',
			image: './assets/images/private-page/password.svg',
		},
	];

	public logOut = async () => {
		await this.authService.logout();
	};

	ngOnInit() {
		this.getUserProfileForCounty();
		this.initForm();
		this.getAvailability();
	}

	toggleMenu() {
		if ($('app-private-layout').hasClass('sidebar-in')) {
			$('app-private-layout').removeClass('sidebar-in');
		} else {
			$('app-private-layout').addClass('sidebar-in');
		}
		// this.sidebarIn = !this.sidebarIn;
	}

	isAdministrator() {
		return this.authService.hasRole(UserRole.Admin);
	}

	isEditor() {
		return this.authService.hasRole(UserRole.Editor);
	}

	initForm(): void {
		this.availForm = this.fb.group({
			availability: [false],
		});
	}

	isSubskrybent() {
		return this.authService.hasRole(UserRole.Subscriber);
	}

	isGuest() {
		return this.authService.hasRole(UserRole.Guest);
	}

	getAvailability(): void {
		this.chatService.getAvailability().subscribe(
			(res) => {
				this.isUserAvailable = res.result;
				this.availForm.patchValue({
					availability: this.isUserAvailable,
				});
			},
			(err) => {
				console.log(err);
			}
		);
		const subFormChanges = this.availForm.valueChanges.subscribe(() => {
			this.setAvailability();
		});
	}

	setAvailability(): void {
		const setAvailSub = this.chatService
			.setAvailability(this.availability)
			.subscribe();


		console.log(this.availability);
	}

	getUserProfileForCounty() {
		this.accountService
			.getAccount()
			.pipe(
				map((x) => {
					this.authService.setUserCounty(x.result.county);
				})
			)
			.subscribe();
	}
}
